// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
// COMPONENTS
import Modal from 'react-bootstrap/Modal';
// CUSTOM COMPONENTS
import LoadingScreen from '../../components/LoadingScreen';
import Section from '../../components/Section';
import FormBlock from '../../components/FormBlock';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import InputBlock from '../../components/InputBlock';
import SelectBlock from '../../components/SelectBlock';
import CheckboxBlock from '../../components/CheckboxBlock';
import Button from '../../components/Button';
//ASSETS
import { Alert } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import * as CompanyService from '../../services/company.service';
import * as UserService from '../../services/user.service';
import UserSaveValidator from '../../helpers/validators/User/UserSaveValidator';

var timeoutId = 0;

const UserManagePage = (props) => {
    const role = Helper.LoggedInUserRole();
    const companyId = Helper.LoggedInCompanyId();

    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [userId, setUserId] = useState(parseInt(urlId) == urlId ? urlId : 0);
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const initialState = {
        id: userId,
        companyId: companyId,
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        username: "",
        password: "",
        isAdmin: false,
        isSalesCoach: false,
        isLocked: false
    };

    const [loading, setLoading] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [isUsed, setIsUsed] = useState(false);
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(companyId);

    const [user, setUser] = useState(initialState);

    useEffect(() => {
        setLoading(true);
        if (userId > 0) {
            UserService.Get(userId).then(res => {
                setUser(res);
                LoadCompanies(res.companyId);
            }).catch(ex => {
                setLoading(false);
            });
        }
        else
            LoadCompanies(selectedCompany);
    }, []);

    const handlePasswordModalOnClose = () => {
        setPassword('');
        setPassword2('');
        setIsPasswordModalOpen(false);
    };

    const UpdatePassword = () => {
        if (password !== password2) {
            alert('Password does not match. Please match the password');
            return;
        }
        setLoading(true);
        UserService.UpdatePassword(userId, password).then(res => {
            setLoading(false);
            handlePasswordModalOnClose();
            Alert({ success: true, message: "Password has been updated!" });
        }).catch(ex => {
            setLoading(false);
        })
    };

    const LoadCompanies = (defaultCompanyId) => {
        if (role == "SuperAdmin") {
            CompanyService.GetAll().then(res => {
                setCompanies(res);
                let companySaved = res.find(x => x.id == defaultCompanyId);
                setSelectedCompany(Helper.SetOptionModel(companySaved.businessName, companySaved.id));
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
        }
        else {
            setLoading(false);
        }
    }

    const checkUsername = (e) => {
        clearTimeout(timeoutId);
        setIsChecking(true);
        timeoutId = setTimeout(() => {
            formik.setFieldTouched('username');
            if (e != undefined && e.target.value == user.username) {
                setIsUsed(false);
                setIsChecking(false);
            }
            else
                UserService.Check(e == undefined ? formik.values.username : e.target.value, selectedCompany >= 0 ? selectedCompany : selectedCompany.value).then(res => {
                    setIsUsed(res);
                    setIsChecking(false);
                });
        }, 300);
    }

    const SaveUser = (values, setSubmitting) => {
        if (isUsed)
            return;
        setLoading(true);
        setSubmitting(true);
        UserService.Save(values).then(res => {
            setUserId(res);
            setSubmitting(false);
            setLoading(false);
            Alert({ success: true, message: "User has been saved!" });
        }).catch(ex => {
            setSubmitting(false);
            setLoading(false);
        });
    }

    const formik = useFormik({
        initialValues: user,
        enableReinitialize: true,
        validationSchema: UserSaveValidator,
        onSubmit: (values, { setSubmitting }) => {
            SaveUser(values, setSubmitting);
        }
    })

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style">
                                <ContentHeader
                                    title={(userId > 0 ? "Update" : "Add New") + " User"}
                                    headerSize="sm"
                                />
                                <FormBlock onSubmit={formik.handleSubmit}>
                                    <Section removeContainer>
                                        {
                                            role == "SuperAdmin" ?
                                                <ContentBlock>
                                                    <SelectBlock
                                                        id="companyId"
                                                        name="companyId"
                                                        inputLabel="Company"
                                                        bordered
                                                        value={selectedCompany}
                                                        options={companies.map(x => Helper.SetOptionModel(x.businessName, x.id))}
                                                        onBlur={() => formik.setFieldTouched("companyId")}
                                                        onChange={option => {
                                                            option = option === null ? [] : option;
                                                            formik.setFieldValue("companyId", option.value);
                                                            setSelectedCompany(option);
                                                        }}
                                                    />
                                                </ContentBlock> : <></>
                                        }

                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                id="firstName"
                                                inputLabel="First Name"
                                                bordered
                                                {...formik.getFieldProps("firstName")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                id="lastName"
                                                inputLabel="Last Name"
                                                bordered
                                                {...formik.getFieldProps("lastName")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                id="email"
                                                inputLabel="Email"
                                                bordered
                                                {...formik.getFieldProps("email")}
                                                inputState={
                                                    formik.touched.email && formik.errors.email
                                                        ? "error"
                                                        : formik.touched.email && formik.errors.email == null ? "success" : ""
                                                }
                                                errorMessage={formik.errors.email}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                id="phoneNumber"
                                                inputLabel="Phone #"
                                                bordered
                                                mask="(999) 999-9999"
                                                {...formik.getFieldProps("phoneNumber")}
                                            />
                                        </ContentBlock>

                                        <ContentBlock cols={6}>
                                            <InputBlock
                                                id="username"
                                                inputLabel="Username"
                                                bordered
                                                {...formik.getFieldProps("username")}
                                                inputState={
                                                    formik.touched.username && (formik.errors.username || isUsed)
                                                        ? "error"
                                                        : formik.touched.username && formik.errors.username == null && !isUsed ? "success" : ""
                                                }
                                                errorMessage={isUsed ? "Username already in use" : formik.errors.username}
                                                onKeyUp={checkUsername}
                                                loading={isChecking}
                                            />
                                        </ContentBlock>

                                        {
                                            userId > 0 ?
                                                <ContentBlock>
                                                    <CustomBlock className="content-container--actions">
                                                        <Button
                                                            text="Change Password"
                                                            className="warning--bg fit-content"
                                                            onClick={() => {
                                                                setIsPasswordModalOpen(true);
                                                            }}
                                                            loading={loading}
                                                        />
                                                    </CustomBlock>

                                                </ContentBlock> :
                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        id="password"
                                                        inputLabel="Password"
                                                        bordered
                                                        type="password"
                                                        {...formik.getFieldProps("password")}
                                                    />
                                                </ContentBlock>
                                        }

                                        <ContentBlock className="padding-vertical">
                                            <CheckboxBlock
                                                label="Is admin?"
                                                id="is-active-checkbox"
                                                defaultChecked={formik.values.isAdmin}
                                                {...formik.getFieldProps("isAdmin")}
                                            />
                                            <CheckboxBlock
                                                label="Is sales coach?"
                                                id="is-sales-coach-checkbox"
                                                defaultChecked={formik.values.isSalesCoach}
                                                {...formik.getFieldProps("isSalesCoach")}
                                            />
                                            <CheckboxBlock
                                                label="Is locked out?"
                                                id="is-locked-out-checkbox"
                                                defaultChecked={formik.values.isLocked}
                                                {...formik.getFieldProps("isLocked")}
                                            />
                                        </ContentBlock>

                                        <CustomBlock className="content-container--actions">
                                            <Button
                                                text="Cancel"
                                                to="/users"
                                                className="danger--bg fit-content"
                                            />
                                            {
                                                role == 'User' || formik.values.companyId == null ? <></> :
                                                    <Button
                                                        text="Save"
                                                        type="submit"
                                                        className="success--bg fit-content"
                                                    />
                                            }
                                        </CustomBlock>
                                    </Section>
                                </FormBlock>
                            </CustomBlock>
                        </Section>

                        <Modal size="md" show={isPasswordModalOpen} onHide={() => handlePasswordModalOnClose()}>
                            <Modal.Header closeButton>
                                <Modal.Title>Update Password</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <InputBlock
                                    id="password"
                                    type="password"
                                    inputLabel="Password"
                                    bordered
                                    placeholder="Enter new password"
                                    value={password}
                                    onChange={({ target }) => {
                                        setPassword(target.value)
                                    }}
                                />
                                <InputBlock
                                    id="password"
                                    type="password"
                                    inputLabel="Re-enter Password"
                                    bordered
                                    placeholder="Enter new password"
                                    value={password2}
                                    onChange={({ target }) => {
                                        setPassword2(target.value)
                                    }}
                                />
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    text="Close"
                                    className="danger--bg fit-content"
                                    onClick={handlePasswordModalOnClose}
                                />
                                <Button
                                    text="Save Changes"
                                    className="success--bg fit-content"
                                    onClick={UpdatePassword}
                                />
                            </Modal.Footer>
                        </Modal>
                    </CustomBlock>
            }
        </>
    )
}

export default UserManagePage;